import React from 'react';
import styled from 'styled-components/macro';
import LayoutWrapper from 'routes/tourOperator/flightCache/comp/utility/layoutWrapper';
import LayoutContent from 'routes/tourOperator/flightCache/comp/utility/layoutContent';
import SwitchMenu from 'routes/tourOperator/flightCache/comp/flightCache/SwitchMenu';
import FlightDefinitionRuleTable from './comp/flightDefinitionRulesTable/FlightDefinitionRulesTable';

function FlightDefinitionRules() {
  return (
    <LayoutWrapper>
      <LayoutContent>
        <SwitchMenu />
        <Root>
          <FlightDefinitionRuleTable />
        </Root>
      </LayoutContent>
    </LayoutWrapper>
  );
}

export default FlightDefinitionRules;

const Root = styled.div`
  display: flex;
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
